import React, { Component } from 'react';
import moment from 'moment/moment';
import { Timeline } from 'primereact/timeline';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { UtilService } from 'hay-core-react';

// Mesmo mapeamento de LinkTemplate.js (marcador aqui usa classe de background sólida, não Tag).
const STATUS_CONFIG = {
  'main.link.status.aguardandoinicio': { cor: 'bg-yellow-500', severity: 'warning', icon: 'pi-clock' },
  'main.link.status.iniciado': { cor: 'bg-blue-500', severity: 'info', icon: 'pi-spin pi-spinner' },
  'main.link.status.finalizado': { cor: 'bg-green-500', severity: 'success', icon: 'pi-check-circle' },
};

function agruparPorDia(itens) {
  const hoje = moment().startOf('day');
  const ontem = moment().subtract(1, 'day').startOf('day');
  const grupos = { hoje: [], ontem: [], anteriores: [] };

  itens.forEach((item) => {
    const dia = moment(item.createdAt).startOf('day');
    if (dia.isSame(hoje)) {
      grupos.hoje.push(item);
    } else if (dia.isSame(ontem)) {
      grupos.ontem.push(item);
    } else {
      grupos.anteriores.push(item);
    }
  });

  return grupos;
}

// Histórico de Links do período (painel direito do Dashboard) — espelho estrutural de
// hay-hotspot/.../DashboardTimeline.js (marcador + Timeline agrupada por dia), adaptado pra
// Link (identificador/template/cliente/status) em vez de UsuarioLog (conexão/desconexão).
class DashboardTimeline extends Component {
  marker(item) {
    const cfg = STATUS_CONFIG[item.status] || { cor: 'bg-gray-400' };
    return (
      <span className={`flex align-items-center justify-content-center border-circle ${cfg.cor} text-white flex-shrink-0`} style={{ width: '2rem', height: '2rem' }}>
        <i className={`pi ${cfg.icon || 'pi-share-alt'}`} />
      </span>
    );
  }

  content(item) {
    const cfg = STATUS_CONFIG[item.status] || { severity: 'secondary', icon: 'pi-question-circle' };
    return (
      <div className="pb-3">
        <div>
          <strong>{item.identificador}</strong>
          {item.template ? <> — {item.template}</> : null}
          <Tag className="ml-2" severity={cfg.severity} icon={`pi ${cfg.icon}`} value={UtilService.traduzir(item.status)} />
          {item.nomecliente ? <Tag className="ml-2" severity="secondary" icon="pi pi-user" value={item.nomecliente} /> : null}
        </div>
        <div className="text-color-secondary text-sm">{moment(item.createdAt).format('DD/MM/YYYY HH:mm')}</div>
      </div>
    );
  }

  renderGrupo(titulo, itens) {
    if (!itens.length) return null;
    return (
      <div key={titulo} className="mb-3">
        <Divider align="left" type="solid">
          <b>{titulo}</b>
        </Divider>
        <Timeline
          value={itens}
          align="left"
          marker={(item) => this.marker(item)}
          content={(item) => this.content(item)}
          pt={{ opposite: { style: { display: 'none' } } }}
        />
      </div>
    );
  }

  render() {
    const { itens } = this.props;

    if (!itens || itens.length === 0) {
      return <div className="text-color-secondary text-center p-4">{UtilService.traduzir('main.dashboard.timeline.semdados')}</div>;
    }

    const grupos = agruparPorDia(itens);

    return (
      <div>
        {this.renderGrupo(UtilService.traduzir('main.dashboard.timeline.hoje'), grupos.hoje)}
        {this.renderGrupo(UtilService.traduzir('main.dashboard.timeline.ontem'), grupos.ontem)}
        {this.renderGrupo(UtilService.traduzir('main.dashboard.timeline.anteriores'), grupos.anteriores)}
      </div>
    );
  }
}

export default DashboardTimeline;
